import { useEffect, useState } from 'react'
import { useConfig } from '../Providers/ConfigProvider';
import { clearTokens, getAccessToken, refreshAccessToken } from '../Services/TokenService';
import { GetCurrentUser } from '../Services/AccountService';

const initialAuthState = {
    user: null,
    custId: null,
    siteId: null,
    whId: null,
    currency: 'PLN',
    selectedCustomer: null,
    selectedCustomerTax: null,
    selectedCustomerData: null,
    initialSiteId: null, //oddział do zamawiania
    initialWhId: null, //magazyn do zamawiania
}

const useHandleAuthState = () => {
    const { api, setLogOutTrigger } = useConfig()

    // Inicjalizacja stanu z sessionStorage jeśli jest zapisany.
    // sessionStorage jest per karta, dzięki czemu każda karta może pracować w innym kontekście kontrahenta (custId),
    // a zalogowanie i tak jest wspólne, bo trzyma je refresh token w cookie httpOnly.
    const [authState, setAuthState] = useState(() => {
        const stored = sessionStorage.getItem('authState')
        return stored ? JSON.parse(stored) : initialAuthState
    })

    const [pending, setPending] = useState(true)
    const [refresh, setRefresh] = useState(false)

    // Zapisujemy każdą zmianę authState do sessionStorage
    useEffect(() => {
        sessionStorage.setItem('authState', JSON.stringify(authState))
    }, [authState])

    useEffect(() => {
        const initializeAuth = async () => {
            let currentToken = getAccessToken()
            try {
                // Jeśli nie mamy AccessTokena, ale mamy RefreshToken (przypadek po F5 lub nowa karta)
                if (!currentToken) {
                    currentToken = await refreshAccessToken(api)
                }
                // Jeśli mamy już AccessToken (albo stary, albo właśnie odświeżony), 
                // a w stanie authState.user jest pusto (bo był refresh strony) – POBIERAMY USERA
                if (currentToken && !authState.user) {
                    const userRes = await GetCurrentUser(api)
                    const newState = {
                        user: userRes.data,
                        custId: userRes.data.custId,
                        siteId: userRes.data.siteId,
                        whId: userRes.data.whId,
                        currency: userRes.data.currency,
                        selectedCustomer: null,
                        selectedCustomerTax: null,
                        selectedCustomerData: null,
                        initialSiteId: userRes.data.siteId,
                        initialWhId: userRes.data.whId,
                    }
                    setAuthState(newState)
                }
            } catch (err) {
                console.error("Sesja wygasła lub błąd serwera przy starcie.")
                clearTokens()
                setLogOutTrigger(prev => !prev)
            } finally {
                setPending(false)
            }
        };

        if (api) {
            initializeAuth()
        }
    }, [api])

    return { authState, pending, setAuthState, setPending, setRefresh }
}

export default useHandleAuthState

